import { gql } from '@apollo/client'

export const REGISTER_NOTIFICATION_TOKEN = gql`
  mutation registerNotificationToken($id: ID!, $type: String!, $token: String!) {
    registerNotificationToken(id: $id, type: $type, token: $token) {
      success
    }
  }
`
